import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import AdminAppBar from '../../adminComponents/AdminAppBar';
import { ToastContainer } from 'react-toastify';
import BackArrows from '../../Form/BackArrow/BackArrows';
import { Divider, MenuItem } from '../../Constant/Constant';
import { CiMenuKebab } from "react-icons/ci";

const FormLeadList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { formName , leadCount } = location.state


    console.log(location.state)
      const [visibleMenu, setVisibleMenu] = useState(false);
        const menuRef = useRef(null);
    const handleBack = () => {
        navigate(-1)
    }

    
      const handleMenuToggle = () => {
        setVisibleMenu(!visibleMenu);
      };
    
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (menuRef.current && !menuRef.current.contains(event.target)) {
            setVisibleMenu(false);
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
    
  return (
    <div className="pt-14 bg-appGrayBackground ">
    <AdminAppBar />
    <ToastContainer />

    {/* {Heading and Search , add } */}
    <div className="mt-[50px] px-6 flex justify-between">
      <div className="flex flex-col gap-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <BackArrows onClick={handleBack} />
            <h1 className="text-[32px] font-semibold">
              {formName} 
            </h1>
          </div>
        </div>
      </div>
{leadCount > 0 && (
          <div className="relative inline-block text-left" ref={menuRef}>
          <div
            onClick={handleMenuToggle}
            className="bg-white cursor-pointer w-[50px] h-[47px] rounded-xl flex items-center justify-center shadow"
          >
            <CiMenuKebab className="text-customGreen text-3xl" />
          </div>
  
          {visibleMenu && (
            <div className="absolute right-0 mt-4 w-64 bg-white rounded-xl shadow-lg z-10 ">
              <div className="absolute -top-2 rounded right-4 w-4 h-4 bg-white rotate-45"></div>
  
              <div className="py-2">
                <MenuItem label="Refresh Facebook forms" />
                <Divider />
                <MenuItem label="Enable all forms" />
                <Divider />
                
                <MenuItem
                  label="Disable all forms"
                  textColor="text-red-600"
                />
              </div>
            </div>
          )}
        </div>
)}
    </div>

    {/* {Lead List } */}

<div className='px-6'>
<div className='bg-white rounded-lg mt-[50px] '>
   {
        leadCount > 0 ? (
            <div className='p-6'>
                <div className='flex flex-col gap-3'>
                    <div className='text-lg font-medium'>Lead Forms {leadCount}</div>
                    <div className='text-slate-700'>Select the Lead Forms {leadCount} you want to receive Facebook Leads forms</div>

                 </div> 

                 <div className='flex mt-5 bg-green-100 rounded-[10px] px-5 py-4 items-center justify-between'>

                    <div className='text-customGreen text-base font-medium'>Lead {leadCount}</div>
                    <div >

                    <label class="inline-flex items-center cursor-pointer">
  <input type="checkbox" value="" class="sr-only peer"/>
  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-customGreen  rounded-full peer  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-customGreen dark:peer-checked:bg-customGreen"></div>

</label>
                    </div>
                    
                </div>  

            </div>
        ) : (
            <div className=' flex flex-col gap-7 justify-center text-center px-6 py-10 '>
                <div className='text-red-500 text-xl font-semibold'>No Lead Forms Found</div>
                <div className='text-slate-700 px-10'>There weren’t any lead forms found on this Facebook Page. If you’ve Previously created lead forms on this page, try refreshing forms or checking your Facebook permission to ensure your Facebook account has access to them</div>
            </div>
        )
    }
   </div>
</div>

    </div>
  )
}

export default FormLeadList